const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
const SET_SELECTED_NOTIFICATION = 'SET_SELECTED_NOTIFICATION';
const SET_MESSAGE_NOTIFICATIONS = 'SET_MESSAGE_NOTIFICATIONS';

const state = function () {
	return {
		notifications: [],
		messageNotifications: [],
		selectedNotification: null,
	};
};

const mutations = {
	[SET_NOTIFICATIONS](state, notifications) {
		state.notifications = notifications;
	},
	[SET_MESSAGE_NOTIFICATIONS](state, messageNotifications) {
		state.messageNotifications = messageNotifications;
	},
	[SET_SELECTED_NOTIFICATION](state, notification) {
		state.notification = notification;
	},
	SOCKET_NOTIFICATIONS_ADD(state, notification) {
		if (notification.type === 'message') {
			state.messageNotifications.unshift(notification);
		} else {
			state.notifications.unshift(notification);
		}
	},
	SOCKET_NOTIFICATIONS_UPDATE_BULK(state, notifications) {
		for (let i = 0; i < notifications.length; i++) {
			const notification = notifications[i];

			state.notifications = state.notifications.map((current) => {
				if (current.id === notification.id) {
					return Object.assign({}, current, notification);
				}
				return current;
			});

			state.messageNotifications = state.messageNotifications.map((current) => {
				if (current.id === notification.id) {
					return Object.assign({}, current, notification);
				}
				return current;
			});
		}
	},
};

const actions = {
	setNotifications({ commit }, notifications) {
		commit(SET_NOTIFICATIONS, notifications);
	},
	setMessageNotifications({ commit }, messageNotifications) {
		commit(SET_MESSAGE_NOTIFICATIONS, messageNotifications);
	},
	setSelectedNotification({ commit }, notification) {
		commit(SET_SELECTED_NOTIFICATION, notification);
	},
};

const getters = {
	notifications: state => state.notifications,
	messageNotifications: state => state.messageNotifications,
	selectedNotification: state => state.selectedNotification,
};

export default {
	state,
	getters,
	actions,
	mutations,
};
